<template>
  <v-container class="my-0 py-1" fluid>
    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar centro de operación..."
          v-model="search"
          append-icon="search"
          single-line
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="
            selected = {};
            createUpdate = true;
          "
          >Crear centro de operación</v-btn
        >
      </v-col>
    </v-row>
    <v-data-table
      :items="cecos"
      :items-per-page="5"
      :headers="headers"
      :search="search"
    >
      <template v-slot:item.monitoreado="{ item }">
        <v-switch
          v-model="item.monitoreado"
          @change="changeMonitoreo(item)"
        ></v-switch>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="primary"
              v-on="on"
              @click="
                selected = item;
                loadCiudades();
                createUpdate = true;
              "
            >
              <i class="fa fa-pencil"></i>
              <!-- <v-icon>mdi-pencil</v-icon> -->
            </v-btn>
          </template>
          <small>Editar</small>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="warning"
              v-on="on"
              @click="
                selectedCeco = item;
                loadHorarios();
                horariosDlg = true;
              "
            >
              <i class="fa fa-calendar"></i>
            </v-btn>
          </template>
          <small>Asignar horarios</small>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="indigo"
              v-on="on"
              @click="
                selectedCeco = item;
                getLink();
                linksDlg = true;
              "
            >
              <i class="fa fa-car"></i>
            </v-btn>
          </template>
          <small>links</small>
        </v-tooltip>
        <v-tooltip bottom v-if="auth.isVertebra() && auth.isSuperadmin()">
          <template v-slot:activator="{ on }">
            <v-btn text small color="error" v-on="on" @click="deleteCeco(item)">
              <i class="fa fa-trash"></i>
              <!-- <v-icon>mdi-pencil</v-icon> -->
            </v-btn>
          </template>
          <small>Eliminar</small>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog width="400" v-model="createUpdate" persistent>
      <v-card>
        <v-card-title
          >{{ selected.id ? "Editar" : "Nuevo" }} centro de
          operación</v-card-title
        >
        <form @submit.prevent="createOrUpdate">
          <v-card-text>
            <v-text-field
              v-model="selected.code"
              outlined
              label="Código"
              required
              :disabled="selected.id"
            ></v-text-field>
            <v-text-field
              v-model="selected.name"
              outlined
              label="Nombre"
              required
            ></v-text-field>
            <v-text-field
              v-model="selected.phone_number"
              outlined
              label="Teléfono"
              required
            ></v-text-field>
            <v-text-field
              v-model="selected.email"
              outlined
              type="email"
              label="Email"
              required
            ></v-text-field>
            <v-select
              outlined
              :items="departamentos"
              label="Departamento"
              v-model="selected.departamento"
              @change="loadCiudades"
              required
            ></v-select>
            <v-select
              label="Ciudad"
              :items="ciudades"
              outlined
              v-model="selected.ciudad"
              required
            ></v-select>
            <v-switch
              label="Monitoreado"
              v-model="selected.monitoreado"
              @change="selected.id ? changeMonitoreo() : null"
            ></v-switch>
          </v-card-text>
          <v-card-actions class="text-right">
            <div class="flex-grow-1"></div>
            <v-btn small color="success" type="submit"
              >Guardar {{ selected.id ? "cambios" : "" }}</v-btn
            >
            <v-btn small color="error" @click="createUpdate = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="horariosDlg" width="700">
      <template>
        <v-card>
          <v-card-title>
            Horarios&nbsp;
            <b>{{ selectedCeco.name }}</b>
          </v-card-title>
          <v-container v-if="!(horarios.length > 0)">
            <v-form lazy-validation ref="form" v-model="valid">
              <v-list-item class="py-5">
                <v-file-input
                  label="Subir archivo"
                  outlined
                  dense
                  @change="validate()"
                  chips
                  v-model="horariosFile"
                  :loading="loading"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      :color="horariosFile.color ? horariosFile.color : null"
                      dark
                      label
                      close
                      small
                      @click:close="cerrar()"
                      >{{ text }}</v-chip
                    >
                  </template>
                </v-file-input>
              </v-list-item>
              <v-list-item>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="!valid"
                  @click="updateHorarios"
                  :loading="loading"
                  >Subir</v-btn
                >
              </v-list-item>
            </v-form>
            <v-divider class="my-4"></v-divider>
            <small
              >Por favor cargue un archivo con el formato horarios para
              asignarlo a ese centro de operación o punto de venta, puede
              descargar una muestra del archivo excel en el siguente
              link:</small
            >
            <br />
            <a :href="`${backend}/files/muestra.xlsx`" target="_blank"
              >Ver archivo de muestra</a
            >
          </v-container>
          <v-card-text>
            <v-simple-table v-if="horarios.length > 0">
              <thead>
                <tr class="text-center">
                  <th>Día de la semana</th>
                  <th>Hora apertura</th>
                  <th>Hora cierre</th>
                  <!-- <th>Acciones</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="h in horarios" :key="h.id">
                  <td>{{ dias[h.ddls] }}</td>
                  <td>{{ h.hora_on }}</td>
                  <td>{{ h.hora_off }}</td>
                  <!-- <td>Test</td> -->
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions v-if="horarios.length > 0">
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="changeHorarios()"
              >Modificar horarios</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog width="700" v-model="linksDlg">
      <template>
        <v-card :loading="loading">
          <v-card-text>
            <v-card-title>Link DataStudio</v-card-title>
            <v-form ref="linkform" lazy-validation v-model="linkValid">
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="ds.linkds"
                    hide-details="auto"
                    dense
                    :rules="[rules.url]"
                    label="Link"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                small
                @click="createUpdateLink"
                :disabled="!linkValid && !ds.linkds"
                >Guardar</v-btn
              >
              <v-btn color="error" small :disabled="!ds.id">Eliminar</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
// import apiv1 from "apiv1";
import { API } from "../../../globals";
import { Auth } from "../../../classes/Auth";

import { apiv1 } from "../../../libs/apiv1";

const auth = new Auth();
const colombia = require("../../../assets/ciudades-colombia.json");

export default Vue.extend({
  name: "Ceco",
  data: () => ({
    headers: [
      { text: "Código", value: "code" },
      { text: "Nombre", value: "name" },
      { text: "Teléfono", value: "phone_number", width: 100 },
      { text: "Email", value: "email" },
      // { text: "Ciudad", value: "city" },
      { text: "Departamento", value: "departamento" },
      { text: "Ciudad", value: "ciudad" },
      { text: "Monitoreado", value: "monitoreado" },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    departamentos: [],
    ciudades: [],
    cecos: [],
    selected: {},
    selectedCeco: {},
    createUpdate: false,
    horariosDlg: false,
    linksDlg: false,
    search: null,
    auth: auth,

    ds: {},

    backend: process.env.VUE_APP_BACKEND,
    horarios: [],
    dias: {
      Monday: "Lunes",
      Tuesday: "Martes",
      Wednesday: "Miércoles",
      Thursday: "Jueves",
      Friday: "Viernes",
      Saturday: "Sábado",
      Sunday: "Domingo",
      Holiday: "Festivo",
    },
    rules: {
      required: (v) => !!v || "Este campo es obligatorio",
      xlsx: (v) =>
        !!/.xlsx$/g.exec(v) || "Solo se admiten archivos Excel(xlsx)",
      url: (v) =>
        !!/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g.exec(
          v
        ) || "No es una url válida",
    },
    valid: true,
    linkValid: true,
    horariosFile: null,
    loading: false,
  }),
  created() {
    // this.validate();
  },
  mounted() {
    this.departamentos = colombia.map(function (item) {
      return item.departamento;
    });
    this.getCecos();
  },
  methods: {
    cerrar() {
      this.horariosFile = null;
      this.validate();
    },
    getCecos: function () {
      apiv1({
        method: "GET",
        url: `cecos?project=${auth.getProject().id}`,
      }).then((res) => {
        this.cecos = res.data;
      });
    },
    loadCiudades: function () {
      this.ciudades = [];
      const found = colombia.find(
        (x) => x.departamento === this.selected.departamento
      );
      if (found) {
        this.ciudades = found.ciudades;
      }
    },
    createOrUpdate: function () {
      let url = `cecos`;
      let method = "POST";
      if (this.selected.id) {
        url += "/" + this.selected.id;
        method = "PUT";
      }
      this.selected.project = auth.getProject().id;
      apiv1({
        method: method,
        url: url,
        data: this.selected,
      }).then((res) => {
        this.getCecos();
        this.selected = {};
        this.createUpdate = false;
        this.$awn.success(res.data);
      });
    },
    deleteCeco: function (item) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar el ceco '${item.name.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$awn.async(
            apiv1({
              method: "DELETE",
              url: `cecos/${item.id}`,
            }),
            (res) => {
              this.getCecos();
              this.$awn.success(res.data);
            },
            (err) => this.$awn.alert(err.response.data)
          );
        }
      });
    },
    changeMonitoreo: function (item) {
      apiv1({
        method: "PUT",
        url: `cecos/monitoreado/${item.id}`,
      }).then((res) => {
        this.getCecos();
        this.$awn.success(res.data);
      });
    },

    // HORARIOS
    changeHorarios() {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea modificar los horarios del punto '${this.selectedCeco.name.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo modificarlos",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$awn.async(
            apiv1({
              method: "DELETE",
              url: `cecos/horarios/${this.selectedCeco.id}`,
            }),
            (res) => {
              this.loadHorarios();
              this.$awn.success(res.data);
            },
            (err) => this.$awn.alert(err.response.data)
          );
        }
      });
    },
    async updateHorarios() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const fd = new FormData();
        fd.append("horarios", this.horariosFile);

        const { data } = await apiv1({
          method: "PUT",
          url: `cecos/horarios/${this.selectedCeco.id}`,
          data: fd,
        });
        this.loading = false;
        this.horariosFile = null;
        this.horariosDlg = false;
        this.$awn.success(data);
      }
    },
    validate() {
      this.valid = !!/.xlsx$/g.exec(this.horariosFile.name);
      this.horariosFile.color = "success";
      if (!this.valid) {
        this.horariosFile.color = "error";
        // this.valid = false;
      }
    },
    loadHorarios: async function () {
      const { data } = await apiv1({
        method: "GET",
        url: `cecos/horarios/${this.selectedCeco.id}`,
      });
      this.horarios = data;
    },
    //LINK DS

    async getLink() {
      this.ds = {};
      this.loading = true;
      const { data } = await apiv1({
        method: "GET",
        url: `ceco/linkds/${this.selectedCeco.id}`,
      });
      this.ds = data || {};
      this.loading = false;
    },
    async deleteLink() {
      const { data } = await apiv1({
        method: "DELETE",
        url: `ceco/linkds/${this.ds.id}`,
      });
      this.$awn.success(data);
    },

    async createUpdateLink() {
      if (this.$refs.linkform.validate) {
        let url = "ceco/linkds";
        let method = "POST";

        const ds = {
          ceco: this.selectedCeco.id,
          link: this.ds.linkds,
        };

        if (this.ds.id) {
          url += `/${this.selectedCeco.id}`;
          method = "PUT";
          delete data.ceco;
        }

        const { data } = await apiv1({
          method: method,
          url: url,
          data: ds,
        });
        this.linksDlg = false;
        this.$awn.success(data);
      }
    },
  },
});
</script>

<style>
</style>